module.exports = __webpack_public_path__ + "prod/1.42.2/img/qrcodebg.541d854b.png";